import React from 'react';
import * as storage from '../../../../services/storage';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { faEye } from '@fortawesome/free-solid-svg-icons'
import services from '../../../../services';
import { trackPromise } from 'react-promise-tracker';
import globals from '../../../../globals';
import { useGetUser } from '../../../../hooks/useGetUser';

const Card = ({ usuario, permiteAlterar, permiteVisualizar }) => {

    const history = useHistory();
    const user = useGetUser();

    // React.useEffect(() => {
    //     fnAcessoEspelho("b6e34b52-38c4-41dc-bdc8-f09677d5be1e");
    //   }, [])
    
      const fnAcessoEspelho = (id) => {
          window.location.href = globals.REACT_APP_PORTAL_AUTO + '?token=' + storage.get('authSistema').token + '&userId=' + id;
      };

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Nome:
            </div>
            <div className={styles.info}>
                {usuario.nome}
            </div>
            <div className={styles.title}>
                Email:
            </div>
            <div className={styles.info}>
                {usuario.email}
            </div>
            <div className={styles.title}>
                CPF
            </div>
            <div className={styles.info}>
                {services.mask.cpf(usuario.cpf)}
            </div>
            <div className={styles.title}>
                Cargo
            </div>
            <div className={styles.info}>
                {usuario.cargo}
            </div>
            <div className={styles.title}>
                Perfil de acesso
            </div>
            <div className={styles.info}>
                {usuario.perfilAcesso}
            </div>
            <div className={styles.title}>
                Código Parceiro BV
            </div>
            <div className={styles.info}>
                {usuario.codigoParceiroBV ?? "--"}
            </div>
            <div className={styles.title}>
                Razão Social
            </div>
            <div className={styles.info}>
                {usuario.razaoSocial}
            </div>
            <div className={styles.actionWrapper}>
                {usuario.status === "Inativo" ? (<div className={styles.encerrado}>INATIVO</div>) : (<div className={styles.andamento}>ATIVO</div>)}

                {
                    permiteAlterar && (
                        <button className={styles.editar} onClick={() => { history.push(`/responsaveis/detalhes?usuario=${usuario.userId}&status=${usuario.status}&acao=A`) }}>
                            Editar
                            <FontAwesomeIcon icon={faUpload} className={styles.icon} />
                        </button>
                    )
                }

                {
                    permiteVisualizar && (
                        <button className={styles.visualizar} onClick={() => { history.push(`/responsaveis/detalhes?usuario=${usuario.userId}&status=${usuario.status}`) }}>
                            Visualizar
                            <FontAwesomeIcon icon={faEye} className={styles.icon} />
                        </button>
                    )
                }
                {
                    permiteVisualizar && user.perfilAcesso === 'Master' && (
                        <button className={styles.visualizar} onClick={() => { fnAcessoEspelho(usuario.userId); }}>
                            Espelho
                            <svg
                                fill="#5CCBE1"
                                height="15px"
                                width="15px"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 512 512"
                                enableBackground="new 0 0 512 512"
                                xmlSpace="preserve"
                            >
                                <path d="M469.3,469.3H42.7V42.7H256L298.7,0h-256C19.1,0,0,19.1,0,42.7v426.7C0,492.9,19.1,512,42.7,512h426.7 c23.6,0,42.7-19.1,42.7-42.7V320l-42.7,42.7V469.3z M85.3,426.7C149.1,255.7,234.7,256,362.7,256v85.3L512,192L362.7,42.7V128 C85.3,128,85.1,341.1,85.3,426.7z" />
                            </svg>        
                        </button>
                    )
                }

            </div>

        </div>
    )
}

export default Card